import Constant from '../../const';
const axios = require('axios');

const getPcareConnection = async () => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat('/integration/pcare/connection'),
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default getPcareConnection;
